import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names with Tailwind conflict resolution.
 * Combines `clsx` (conditional classes) with `tailwind-merge` (deduplication).
 *
 * @param inputs - Class values (strings, arrays, objects, etc.)
 * @returns Merged class name string
 *
 * @example
 * ```ts
 * cn('px-4 py-2', isActive && 'bg-blue-500', 'px-6') // 'py-2 px-6 bg-blue-500'
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
